import React from 'react';
import { useContext } from 'react';
import { InformationContext } from 'src/consumer/context/InformationContext';
import { AppExclusiveContainer, AppExclusiveText, GenericCardBackground, GenericCardCategory, GenericCardContainer, GenericCardTitle, GenericCardsContainer } from './GenericCardStyle';
import { SetupContext } from 'src/consumer/context/SetupContext';
import { getGenericCardDetails } from 'src/consumer/helpers/genericCardHelper';
import { mediaURL } from 'src/consumer/services';
import Star_Image from "src/assets/unlimited_star.png"
import { StyledCardInfoSeparator, StyledCourseCategory, StyledCourseTitle } from '../BrowserByCategory/BrowserByCategoryStyle';
import { IconImage } from 'src/shared/styled/sharedPrimitives';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle';

export const renderCardsList = (props, setupData, setInformationModalData) => {
    const { cardsType, cardsCategory, cardsData } = props;

    return cardsData?.map((item, index) => {
        const { imgId, category, title } = getGenericCardDetails(item, setupData, cardsType, cardsCategory);

        return (
            <GenericCardContainer key={index} onClick={() => {
                if (setupData?.clientType === "mobileBrowser") {
                    window.open("https://aumhum.page.link/app");
                } else {
                    setInformationModalData({ showModal: true, data: { toShow: "app_exclusive" } })
                }
            }}>
                <GenericCardBackground src={`${mediaURL}${imgId}`} />
                <AppExclusiveContainer>
                    <GenericCardCategory>{category}</GenericCardCategory>
                    <StyledCardInfoSeparator />
                    <GenericCardTitle>{title}</GenericCardTitle>
                    <AppExclusiveText>App Exclusive<IconImage src={Star_Image} w={20} h={20} /> </AppExclusiveText>
                </AppExclusiveContainer>
            </GenericCardContainer>
        )
    })
}

const GenericCards = (props) => {

    const { informationModalData, setInformationModalData } = useContext(InformationContext);
    const { setupData } = useContext(SetupContext);

    const { areTileItemsHovered } = props;
    const cardRef = useRef();
    const [leftButtonVisible, setLeftButtonVisible] = useState(false);
    const [rightButtonVisible, setRightButtonVisible] = useState(false);
    const handleScrollLeft = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft -= scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScrollRight = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft += scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScroll = (event) => {
        const container = event?.target;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }
    useEffect(() => {
        const container = cardRef?.current;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }, []);


    return (
        <GenericCardsContainer ref={cardRef} onScroll={handleScroll}>
            {areTileItemsHovered && leftButtonVisible &&
                <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
            }
            {renderCardsList(props, setupData, setInformationModalData)}
            {areTileItemsHovered && rightButtonVisible &&
                <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
            }
        </GenericCardsContainer>
    )
}

export default GenericCards;
